import { shuffleArray } from './utils.js';
import { createShapeForChar } from './shapeResolver.js';
import { createGetShapeFrames } from './shapeFrames.js';
import { initArtistSections } from './artistSections.js';
import { renderAnimatedText, initInlineAnimatedText } from './animatedText.js';
import { renderShapeAnimation, initShapeAnimations } from './shapeAnimations.js';
import { tickAnimation, startAnimationLoop } from './animationLoop.js';
import { initGrassField } from './grassField.js';

export function initView(options = {}) {
	const viewShape = document.getElementById('viewShape');
	const viewStatus = document.getElementById('viewStatus');
	const grid = document.getElementById('artistGrid');
	const cellTemplate = document.getElementById('artistCellTemplate');

	if (!cellTemplate) {
		return;
	}

	const shapeKeys = options.shapeKeys || [];
	const defaultViewShape = options.defaultViewShape || 'star';
	let selectedFallbackShape = options.initialShape || defaultViewShape;
	let inlineCells = [];
	let artistContainers = [];
	let observer = null;
	let loopId = null;

	const getShapeFrames = createGetShapeFrames();
	const shapeForChar = createShapeForChar(
		shapeKeys,
		defaultViewShape,
		() => selectedFallbackShape
	);

	function setStatus(text) {
		if (viewStatus) {
			viewStatus.textContent = text;
		}
	}



	async function refreshArtistSections() {
		if (observer) {
			observer.disconnect();
			observer = null;
		}

		const result = await initArtistSections({
			grid,
			shapeForChar,
			getShapeFrames,
			shuffleArray,
			setStatus,
		});
		artistContainers = result.artistContainers;
		observer = result.observer;
	}

	async function renderAnimatedTextImpl(container, text, addToGlobalCells = true) {
		await renderAnimatedText({
			container,
			text,
			addToGlobalCells,
			cellTemplate,
			shapeForChar,
			getShapeFrames,
			shuffleArray,
			inlineCells,
		});
	}

	async function renderShapeAnimationImpl(container, shape, count, shapes = []) {
		await renderShapeAnimation({
			container,
			shape,
			shapes,
			count,
			cellTemplate,
			getShapeFrames,
			shuffleArray,
			inlineCells,
		});
	}

	if (viewShape) {
		viewShape.value = selectedFallbackShape;
		viewShape.addEventListener('change', async () => {
			selectedFallbackShape = viewShape.value;
			await refreshArtistSections();
		});
	}

	(async function init() {
		await initGrassField();

		await initInlineAnimatedText({ cellTemplate, renderAnimatedTextImpl });
		await initShapeAnimations({ renderShapeAnimationImpl });
		await refreshArtistSections();

		if (loopId) {
			clearInterval(loopId);
		}
		loopId = startAnimationLoop(() => tickAnimation(inlineCells, artistContainers), 130);
	})();
}
